import { createStore, compose, applyMiddleware } from "redux";
import thunk from "redux-thunk";
//import logger from 'redux-logger'

import reducer from "../reducers";

// Use redux devtools compose if available
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

export default createStore(reducer, composeEnhancers(applyMiddleware(thunk/*, logger*/)));